/**
 * toggle.js
 *
 * Handles the department dropdown and the ajax requesting for
 * the reload of the section to display the selected department.
 *
 */

export default class navigation {

    constructor() {

        this.settings = {

            toggle      : document.getElementById( 'menu-toggle' ),
            toggleClose : document.getElementById( 'menu-toggle-close' ),
            body        : document.getElementsByTagName( 'body' )[0],
            activeClass : 'js-menu-open'

        }

    }

    init() {

        if ( null !== this.settings.toggle ) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        let s = this.settings;

        s.toggle.addEventListener( 'click', event => {
            event.preventDefault();
            this.activeClass();
        });

        s.toggleClose.addEventListener( 'click', event => {
            event.preventDefault();
            this.activeClass();
        });

        document.addEventListener( 'keydown', event => {
            if( 'Escape' == event.code ) {
            s.body.classList.remove( s.activeClass );
            }
        } );

    }

    activeClass() {

        let s = this.settings;

        if ( s.body.classList.contains( s.activeClass ) ) {
            s.body.classList.remove( s.activeClass );
        } else {
            s.body.classList.add( s.activeClass );
        }

    }

}